import { Routes, RouterModule } from '@angular/router';
import { FormStatusScreenComponent } from './form-status.component';

const formStatusRoutes: Routes = [
];

export const FormStatusRouter = RouterModule.forChild(formStatusRoutes);